import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import {
  getAllowedSignupRoute,
  getSignupRouteKey,
  isSignupRouteAllowed
} from './signup-user';

@Injectable()
export class SignupStepGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url = state.url || '';
    if (isSignupRouteAllowed(url)) {
      return true;
    }
    const target = getAllowedSignupRoute();
    if (target && getSignupRouteKey(target) !== getSignupRouteKey(url)) {
      this.router.navigateByUrl(target);
    }
    return false;
  }
}
